export const CHINA_TIME_ZONE = "Asia/Shanghai";

export function toChinaDateString(date = new Date()) {
  if (date == null || date === "") return date;

  const parsed = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(parsed.valueOf())) return undefined;

  return parsed.toLocaleDateString("en-CA", { timeZone: CHINA_TIME_ZONE });
}

export function toChinaDateTimeString(date = new Date()) {
  if (date == null || date === "") return date;

  const parsed = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(parsed.valueOf())) return undefined;

  return parsed.toLocaleString("zh-CN", {
    timeZone: CHINA_TIME_ZONE,
    hour12: false,
  });
}
